import $ from 'jquery';

// Miscellaneous scripts relating to the checkout process
// Some things are handled generically in the ecommerce.js file,
// but custom stuff for Nectar only is here

$(function() {

    initHandleCheckoutButton();

    initCVCInfo();

});


function initHandleCheckoutButton() {

    //console.log('initHandleCheckoutButton');

    $('.custom-order-details-wrapper input[type=submit]').unbind('click');
    $('.custom-order-details-wrapper input[type=submit]').on('click', function(e) {

        //console.log('submit click');

        // Check default fields have content

        let $nameInput = $('input[name=\'custom_json[name]\']');
        if ($nameInput.val() == '') {
            $nameInput.css('border', 'solid 2px red');
            e.preventDefault();
        }

    });

}


function initCVCInfo() {

    $('.security-code-info i').unbind('click');
    $('.security-code-info i').on('click', function(e) {

        $('.security-code-info div').toggleClass('show');

    });


}
